import React, { useMemo } from 'react';
import { useTranslation } from '../../../i18n/use-translation';
import * as styles from './choose_modal.module.sass';
import { ChooseRoleItem } from './components/ChooseRoleItem';
import { RoleItem } from './components/type/role-item';
import { ChooseRoleProps } from './type/props';

export const ChooseForm = React.memo((props: ChooseRoleProps) => {
  const { t } = useTranslation();

  const items = useMemo(() => {
    return props.config.map((item: RoleItem) => {
      return <ChooseRoleItem onClick={props.onChooseHandler} item={item} key={item.key} />;
    });
  }, []);

  return (
    <>
      <div className={styles.small_modall_header}>
        <p className={styles.header_content}>{t('choose_role')}</p>
      </div>
      <div className={styles.modal_body}>
        <ul className={styles.modal_register_role__list}>{items}</ul>
      </div>
    </>
  );
});
